import { FC, ReactNode, useContext } from 'react'

import { Text } from '@hhgtech/hhg-components/mantine'
import { DataTrackingTypeHTMLElement } from '@hhgtech/hhg-components/types'
import { Box, BoxProps } from '@mantine/core'

import useStyles from './index.styles'
import { FeatureCardContext } from '../../context'

type SectionNameProps = {
  icon?: string | ReactNode
  children: string
} & BoxProps &
  DataTrackingTypeHTMLElement

const FeatureCardSectionName: FC<SectionNameProps> = ({
  icon = '',
  children,
  styles,
  classNames,
  className,
  ...rest
}) => {
  const { url } = useContext(FeatureCardContext)
  const { classes, cx } = useStyles(undefined, {
    name: 'FeatureCard__SectionName',
    styles,
    classNames,
  })

  return (
    <Box
      {...rest}
      className={cx(classes.root, className)}
      component={url ? 'a' : 'div'}
      href={url}
    >
      {icon && (
        <Box className={classes.icon}>
          {typeof icon === 'string' ? (
            <img loading="lazy" width={20} height={20} src={icon} alt="" />
          ) : (
            icon
          )}
        </Box>
      )}
      <Text size="title2" weight="semiBold" as="span" className={classes.label}>
        {children}
      </Text>
    </Box>
  )
}

FeatureCardSectionName.displayName = 'FeatureCardSectionName'

export default FeatureCardSectionName
